<template>
  <vs-row>
    <vs-col>
      <vs-row vs-justify="flex-end" class="text-primary lh-1 text-ellipsis">
        <vs-chip :color="BOOKING_STATE.colorof(booking.bookingState)">{{
          BOOKING_STATE.nameof(booking.bookingState)
        }}</vs-chip>
        <vs-chip
          v-if="booking.isEnded()"
          :color="BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.Ended)"
          >{{
            getBookingTagTranslation(BOOKING_TYPE_TAG.Ended)
          }}</vs-chip
        >
           <vs-chip
          v-if="booking.isWalkIn()"
          :color="BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.WalkIn)"
          >{{
            getBookingTagTranslation(BOOKING_TYPE_TAG.WalkIn)
          }}</vs-chip
        >
        <vs-chip
          v-if="booking.isAwaitingConfirmation()"
          :color="BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.AwaitsConfirmation)"
          >{{
            getBookingTagTranslation(BOOKING_TYPE_TAG.AwaitsConfirmation)
          }}</vs-chip
        >

      </vs-row>
      <vs-row vs-justify="flex-end" class="text-grey lh-1 text-ellipsis"
        ><small>Status</small></vs-row
      >

      <vs-row vs-justify="flex-end" class="text-primary lh-1 text-ellipsis">
        <span v-bind:class="getArrivalStateClass()">{{
         statusTitle
        }}</span>
      </vs-row>

      <vs-row
        vs-justify="flex-end"
        v-if="booking.isOvertime()"
        class="text-primary lh-1 text-ellipsis"
      >
        <span class="text-red text-opacity-70">Overtime</span>
      </vs-row>
      <vs-row vs-justify="flex-end">
        <booking-action-selector
          @booking-action-selected="handleBookingActionSelected($event)"
        />
      </vs-row>

      <vs-row vs-justify="flex-end" class="mt-24" v-if="hasPermissionToEditCustomer && booking.bookingCustomerId ">
        <router-link :to="routeToEditCustomer" class="mt-4"> 
          <vs-button size="small">Edit customer</vs-button>
        </router-link>
      </vs-row>
      
    </vs-col>
  </vs-row>
</template>

<script>
import { BOOKING_STATE, ARRIVAL_STATE, BOOKING_TYPE_TAG, Booking } from "@/store/modules/marcom/data-model/bookings";
import BookingActionSelector from "../../../../components/bookings/BookingActionSelector.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    BookingActionSelector
  },
  props: {
    booking: Object,
  },
  model: {
    prop: "booking",
    event: "booking-states-updated",
  },
  data() {
    return {
      BOOKING_STATE,
      ARRIVAL_STATE,
      BOOKING_TYPE_TAG
    };
  },
  computed: {
    ...mapGetters({
      themeBookingTags: "marcom/themeBookingTags",
      getBookingTagTranslation: "marcom/getBookingTagTranslation",
    }),
      routeToEditCustomer(){
        if(!this.booking.bookingCustomerId) return ""
        return `/crm/guest/${this.booking.bookingCustomerId.id}`
      },
      hasPermissionToEditCustomer(){
        return this.hasPermission("vp.crm.guestprofiles.view")
      },
      statusTitle(){
        console.log(this.booking.arrivalState,ARRIVAL_STATE.Arrived)
        if(this.booking){
        if( this.booking.arrivalState == ARRIVAL_STATE.Arrived){
          console.log(this.arrivedCount, this.booking.guestCount)
              return this.arrivedCount < this.booking.guestCount ? "Partial arrival" + ` ${this.arrivedCount}/${this.booking.guestCount}` : "Arrived" 
        }
       return ARRIVAL_STATE.nameof(this.booking.arrivalState)
         }
         return ""
      },
      arrivedCount(){
      if(this.booking){
      if(this.booking.arrivals.length == 0) {return 0}
      var arrived = 0
      this.booking.arrivals.forEach(arrival => {
          arrived += arrival.numPeopleArrived
      });
      return arrived
     
      }
      
    }
  },
  methods: {
    handleBookingActionSelected(bookingAction) {
      if (bookingAction.type === "ARRIVAL_STATE") {
        this.booking.arrivalState = bookingAction.value;
      } else if (bookingAction.type === "BOOKING_TYPE_TAG") {
        if (this.booking.tags) {
          let index = this.booking.tags.findIndex(
            (t) => t === bookingAction.value
          );
          if (index < 0) this.booking.tags.push(bookingAction.value);
          else this.booking.tags.splice(index, 1);
        } else {
          this.booking.tags = [];
          this.booking.tags.push(bookingAction.value);
        }
      }
      this.$emit('booking-states-updated', Object.assign(new Booking(), this.booking));
    },
    getArrivalStateClass() {
      if (this.booking.bookingState == BOOKING_STATE.Seated)
        return { "text-green": true, "text-opacity-70": true };
    },
  },
};
</script>

<style lang="scss" scoped>
.text-red {
  color: #aa0000;
}
.text-green {
  color: #00891b;
}
</style>
